import { FC } from 'react';
import { Outlet } from 'react-router-dom';

export const PublicLayout: FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <main>
        <Outlet />
      </main>
    </div>
  );
}; 